import axios from "axios";

// Aqui es donde se validaran y exportaran las variables de entorno
export const BASE_URL = process.env.REACT_APP_BASE_URL
export const API_URL = process.env.REACT_APP_API_URL;
export const CRYPTO_PASS = process.env.REACT_APP_CRYPTO_PASS;
const API_KEY = process.env.REACT_APP_FIREBASE_API_KEY;
const AUTH_DOMAIN = process.env.REACT_APP_FIREBASE_AUTH_DOMAIN;
const DATABASE_URL = process.env.REACT_APP_FIREBASE_DATABASE_URL;
const PROJECT_ID = process.env.REACT_APP_FIREBASE_PROJECT_ID;
const STORAGE_BUCKET = process.env.REACT_APP_FIREBASE_STORAGE_BUCKET;
const MESSAGING_SENDER_ID = process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID;
const APP_ID = process.env.REACT_APP_FIREBASE_APP_ID;

export const FIREBASE_CONFIG = {
    apiKey: API_KEY,
    authDomain: AUTH_DOMAIN,
    databaseURL: DATABASE_URL,
    projectId: PROJECT_ID,
    storageBucket: STORAGE_BUCKET,
    messagingSenderId: MESSAGING_SENDER_ID,
    appId: APP_ID
};


export const axiosCreate = axios.create({
    baseURL: API_URL,
    timeout: 20000,
});